import { isTenantInAllowlist } from '../utils/tenantUtils';
import { HANDOFF_SESSION_PARAM } from '../asb_modules/availabill/constants/handoffConfig';

const FIELD_STATES_TENANTS = ['payback', 'syngenio'] as const;

export const isFieldStatesEnabledForTenant = (): boolean =>
  isTenantInAllowlist(FIELD_STATES_TENANTS);

// Params that trigger an async prefill fetch on load. Checked here since the
// component doing the fetch loads too late to set the loading flag itself.
// Scoped per tenant to avoid collisions.
const EXTERNAL_PREFILL_TRIGGERS: {
  tenants: readonly string[];
  param: string;
}[] = [
  { tenants: ['payback'], param: 'code' }, // OAuth2 callback param
  { tenants: ['availabill'], param: HANDOFF_SESSION_PARAM },
];

export const hasExternalPrefillInProgress = (): boolean => {
  const params = new URLSearchParams(window.location.search);
  return EXTERNAL_PREFILL_TRIGGERS.some(
    ({ tenants, param }) => isTenantInAllowlist(tenants) && params.has(param)
  );
};
